"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SevenAnniversary = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var zl_1 = require("../../model/zl");
var service_1 = require("../../../library/base/service");
var SevenAnniversary = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(SevenAnniversary, _super);
    function SevenAnniversary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '众禄基金七日年化';
        _this.code = '106023';
        _this.desc = '众禄基金七日年化';
        _this.requestParams = new zl_1.SevenAnniversaryRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return SevenAnniversary;
}(service_1.BaseService));
exports.SevenAnniversary = SevenAnniversary;
//# sourceMappingURL=sevenAnniversary.js.map